import { useLightMode } from '@/hooks/useLightMode'
import { useDispatch } from 'react-redux'

import { BadgeCounter, Box, Skeleton } from '@hivewatch/dark'

import { useGetNotificationCountQuery } from '@/graphql/appsync-notifications'
import { useAppSelector } from '@/redux/hooks'
import {
  selectNotificationCount,
  setNotificationCount,
} from '@/redux/notifications/notificationsSlice'

export const InboxItemsCount = () => {
  const colorScheme = useLightMode()
  const count = useAppSelector(selectNotificationCount)
  const dispatch = useDispatch()

  const { loading: isLoading } = useGetNotificationCountQuery({
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
    onCompleted: (data) => {
      dispatch(
        setNotificationCount(data?.getNotificationCount?.notificationCount)
      )
    },
  })

  return isLoading ? (
    <Skeleton borderRadius='8px' height='22px' width='24px' />
  ) : (
    <Box
      as='span'
      data-testid='notificationsTab_inbox_countBadge'
      display='inline-flex'
    >
      <BadgeCounter
        colorScheme={colorScheme}
        count={count}
        // Unread inbox count caps at "9+", matching the pre-rebrand badge.
        maxCount={9}
        variant='incident'
      />
    </Box>
  )
}
